import { MODE_OF_TRANSPORT_EXPRESS_ROAD } from 'shared/ncts/common/constants'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0931Validator = {
  validateConsignmentConsigneeContactPersonRequirement: ({
    security,
    additionalDeclarationType,
  }: {
    security: string
    additionalDeclarationType?: string
  }): RuleResult => {
    if (!['1', '3'].includes(security)) return 'NOT_ALLOWED'

    return additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'
  },
  validateHouseConsignmentContactPersonRequirement: ({
    security,
    specificCircumstanceIndicator,
    additionalDeclarationType,
  }: {
    security: string
    specificCircumstanceIndicator?: string
    additionalDeclarationType?: string
  }): RuleResult => {
    if (!['1', '3'].includes(security) || specificCircumstanceIndicator !== MODE_OF_TRANSPORT_EXPRESS_ROAD) return 'NOT_ALLOWED'

    return additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'
  },
}

export default C0931Validator
